"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Recipients/AddProgress.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _campaignRecipientsAdd = require('shared/services/campaignRecipientsAdd');
var _format = require('web/screens/Broadcast/format');
var _addingRecipients = require('web/screens/Broadcast/addingRecipients');

var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');
var _Tooltip = require('web/components/Tooltip');

/* Below this width the bar has no room for its counts: it shows a
 * percentage, and the counts move to its tooltip (frame 1f). */
 const NARROW_WIDTH = 640; exports.NARROW_WIDTH = NARROW_WIDTH

const DISMISSED_KEY = 'broadcast.recipientsAdd.dismissed.'

const isDismissedStored = (taskKey) => {
  try {
    return window.localStorage.getItem(DISMISSED_KEY + taskKey) === '1'
  } catch (e) {
    return false
  }
}

const storeDismissed = (taskKey) => {
  try {
    window.localStorage.setItem(DISMISSED_KEY + taskKey, '1')
  } catch (e2) {
    // Private mode or blocked storage: dismissed for this page only.
  }
}

/* Whether the element is narrower than `width`, following its size. */
const useIsNarrow = (ref, width, isShown) => {
  const [isNarrow, setIsNarrow] = _react.useState.call(void 0, false)
  _react.useLayoutEffect.call(void 0, 
    () => {
      const el = ref.current
      if (!el || !isShown) return
      const measure = (w) => setIsNarrow(w > 0 && w < width)
      measure(el.getBoundingClientRect().width)
      if (typeof ResizeObserver === 'undefined') return
      const observer = new ResizeObserver(entries => {
        const entry = entries[entries.length - 1]
        if (entry) measure(entry.contentRect.width)
      })
      observer.observe(el)
      return () => observer.disconnect()
    },
    [ref, width, isShown],
  )
  return isNarrow
}

const countsText = (add) => [
  `${_format.formatCount.call(void 0, add.NewPatients)} new`,
  `${_format.formatCount.call(void 0, add.ExistingPatients)} existing`,
  ...(add.CantAdd > 0 ? [`${_format.formatCount.call(void 0, add.CantAdd)} can't be added`] : []),
].join(' · ')

const rowsText = (add) =>
  `${_format.formatCount.call(void 0, add.RowsDone)} of ${_format.formatCount.call(void 0, add.TotalRows)} rows`







/* P2' (Option 1, frames 1a–1f): a background CSV Add in the recipients
 * screen's progress slot, in the sending bar's shape with a lilac fill.
 * While it runs: the file, rows done and the counts (a percentage when
 * narrow); once it ends, a one-line summary with Details and ×. Shown on
 * drafts too: the wizard's Recipients step and the campaign page. */
const AddProgress = ({ campaignKey, onAddFromCsv }) => {
  const add = _addingRecipients.useRecipientsAdd.call(void 0, campaignKey)
  const barRef = _react.useRef(null)
  const isRunning = _optionalChain([add, 'optionalAccess', _ => _.State]) === 'running'
  const isNarrow = useIsNarrow(barRef, exports.NARROW_WIDTH, isRunning)
  const [dismissed, setDismissed] = _react.useState(null)
  const [isDetailsOpen, setIsDetailsOpen] = _react.useState.call(void 0, false)

  const taskKey = _nullishCoalesce(_optionalChain([add, 'optionalAccess', _2 => _2.TaskKey]), () => ( ''))
  const onDismiss = _react.useCallback.call(void 0, 
    () => {
      storeDismissed(taskKey)
      setDismissed(taskKey)
    },
    [taskKey],
  )
  const onOpenDetails = _react.useCallback.call(void 0, 
    () => {
      setIsDetailsOpen(true)
      // Pushes leave out the failed rows: read them for Details.
      _actions2.default.getCampaignRecipientsAdds([campaignKey]).catch(() => undefined)
    },
    [campaignKey],
  )
  const onCloseDetails = _react.useCallback.call(void 0, () => setIsDetailsOpen(false), [])

  if (!add) return null
  if (!isRunning && (dismissed === add.TaskKey || isDismissedStored(add.TaskKey))) return null

  const details = (
    _react2.default.createElement(AddDetails, { isOpen: isDetailsOpen, add: add, onClose: onCloseDetails, __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}} )
  )

  if (isRunning) {
    const percent = _campaignRecipientsAdd.addPercent.call(void 0, add)
    const isStarting = add.RowsDone === 0
    const label = isNarrow
      ? `Adding recipients · ${percent}%`
      : isStarting
        ? `Adding recipients from ${add.FileName} · starting…`
        : `Adding recipients from ${add.FileName} · ${rowsText(add)}`
    const tooltip = isNarrow
      ? _react2.default.createElement(_react2.default.Fragment, null,  rowsText(add) , " · "  ,  countsText(add) , _react2.default.createElement('br', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 121}} ),  _addingRecipients.startedByText.call(void 0, add) )
      : _react2.default.createElement(_react2.default.Fragment, null,  _addingRecipients.startedByText.call(void 0, add) , _react2.default.createElement('br', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 122}} ),  rowsText(add) , " done. You can leave this page; it keeps going."         )
    return (
      _react2.default.createElement(_Tooltip.HoverTooltip, {
        place: "bottom",
        type: "dark",
        className: "recipients-add-progress--container",
        content: _react2.default.createElement('span', { className: "recipients-add-progress--tooltip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 128}},  tooltip ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 124}}

        , _react2.default.createElement('div', {
          ref: barRef,
          role: "progressbar",
          'aria-label': "Adding recipients" ,
          'aria-valuemin': 0,
          'aria-valuemax': 100,
          'aria-valuenow': percent,
          'aria-valuetext': label,
          className: _classBuilder2.default.call(void 0, 'recipients-add-progress', isNarrow && 'recipients-add-progress--narrow'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 130}}

          /* A sliver while it starts, so the bar reads as moving. */
          , _react2.default.createElement('span', { className: "recipients-add-progress--fill", style: { width: `${Math.max(percent, 2)}%` }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 141}} )
          , _react2.default.createElement('span', { className: "recipients-add-progress--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 142}},  label )
          ,  !isNarrow && !isStarting && (
            _react2.default.createElement('span', { className: "recipients-add-progress--counts", __self: this, __source: {fileName: _jsxFileName, lineNumber: 144}},  countsText(add) )
          )
        )
      )
    )
  }

  const isFinished = add.State === 'finished'
  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', {
        role: "status",
        'aria-label': "Recipients added" ,
        className: _classBuilder2.default.call(void 0, 'recipients-add-summary', isFinished ? 'recipients-add-summary--ok' : 'recipients-add-summary--bad'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 154}}

        , _react2.default.createElement('span', { className: "recipients-add-summary--icon", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 159}},  isFinished ? '✓' : '⚠' )
        , _react2.default.createElement('span', { className: "recipients-add-summary--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 160}}
          ,  isFinished
            ? (
                _react2.default.createElement(_react2.default.Fragment, null
                  , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 164}}, "Added " ,  _format.pluralize.call(void 0, add.Added, 'recipient', 'recipients') )
                  ,  ` from ${add.FileName} · ${countsText(add)}` 
                )
              )
            : add.State === 'failed'
              ? _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 169}},  _addingRecipients.addFailedText.call(void 0, add) )
              : _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 170}},  _addingRecipients.addStoppedText.call(void 0, add) )
          
        )
        ,  !isFinished && onAddFromCsv && (
          _react2.default.createElement('button', { type: "button", className: "recipients-add-summary--link", onClick: onAddFromCsv, __self: this, __source: {fileName: _jsxFileName, lineNumber: 174}}, "Add the file again"

          )
        )
        , _react2.default.createElement('button', { type: "button", className: "recipients-add-summary--link", onClick: onOpenDetails, __self: this, __source: {fileName: _jsxFileName, lineNumber: 178}}, "Details")
        , _react2.default.createElement('button', { type: "button", 'aria-label': "Dismiss", className: "recipients-add-summary--close", onClick: onDismiss, __self: this, __source: {fileName: _jsxFileName, lineNumber: 179}}, "×")
      )
      ,  details 
    )
  )
}

/* Details: the Add's counts, the rows it couldn't write and who started it. */
const AddDetails = ({ isOpen, add, onClose }) => {
  const counts = [
    ['Rows', add.TotalRows],
    ['Rows done', add.RowsDone],
    ['Added', add.Added],
    ['New patients', add.NewPatients],
    ['Existing patients', add.ExistingPatients],
    ['Already in the campaign', add.AlreadyInCampaign],
    ['Updated values', add.UpdatedRecipients],
    ["Can't be added", add.CantAdd],
  ]
  const failed = _nullishCoalesce(add.FailedRows, () => ( []))
  return (
    _react2.default.createElement(_Modal2.default, { isOpen: isOpen, title: `Adding from ${add.FileName}`, size: "xs", className: "recipients-add-details", onClose: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 200}}
      , _react2.default.createElement('dl', { className: "recipients-add-details--counts", __self: this, __source: {fileName: _jsxFileName, lineNumber: 201}}
        ,  counts.map(([label, n]) => (
          _react2.default.createElement(_react2.default.Fragment, { key: label, __self: this, __source: {fileName: _jsxFileName, lineNumber: 203}}
            , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 204}},  label )
            , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 205}},  _format.formatCount.call(void 0, n) )
          )
        ))
      )
      ,  failed.length > 0 && (
        _react2.default.createElement(_react2.default.Fragment, null
          , _react2.default.createElement('p', { className: "recipients-add-details--heading", __self: this, __source: {fileName: _jsxFileName, lineNumber: 211}}, "Rows that couldn't be added"    )
          , _react2.default.createElement('ul', { 'aria-label': "Rows that couldn't be added"    , className: "recipients-add-details--rows", __self: this, __source: {fileName: _jsxFileName, lineNumber: 212}}
            ,  failed.map(r => (
              _react2.default.createElement('li', { key: r.Row, __self: this, __source: {fileName: _jsxFileName, lineNumber: 214}}, _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 214}}, "Row " ,  r.Row ), " · "  ,  r.Error )
            ))
          )
        )
      )
      , _react2.default.createElement('div', { className: "recipients-add-details--foot", __self: this, __source: {fileName: _jsxFileName, lineNumber: 219}}
        , _react2.default.createElement('span', { className: "recipients-add-details--started", __self: this, __source: {fileName: _jsxFileName, lineNumber: 220}},  _addingRecipients.startedByText.call(void 0, add) )
        , _react2.default.createElement(_Form.Button, { onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 221}}, "Close")
      )
    )
  )
}

exports. default = _react.memo.call(void 0, AddProgress)
